import { createAxiosClient } from "@ntg/component-library/utilities";
import { IComparisonInfo } from "../../declarations/types";

export const getRouteVersionComparison = async (
    csRouteID: number,
    routeId: string,
    dataAreaId: string,
    productionSiteId: string,
    itemNumber: string,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/RouteVersion/RouteVersionComparisonInfoD365`,
        {
            keys: {
                csRouteID,
                routeId,
                dataAreaId,
                productionSiteId,
                itemNumber,
            },
        },
    );
    return response.data;
};
